<template>
  <v-container>
    <h2
      class="hidden-lg-and-up mx-5 mb-5 font-weight-light"
      style="color: #333"
    >{{ this.$route.name }}</h2>

    <v-card class="pa-10 ma-5" light>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="12" md="8">
            <v-text-field
              prepend-icon="mdi-account"
              v-model="name"
              :counter="48"
              :rules="nameRules"
              label="Nama Lengkap"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              prepend-icon="mdi-gender-male-female"
              v-model="selectGender"
              :items="genders"
              :rules="[v => !!v || 'Harus pilih salah satu']"
              label="Jenis Kelamin"
              required
            ></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-text-field prepend-icon="mdi-city" v-model="birthPlace" label="Tempat Lahir"></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-menu
              ref="birth"
              v-model="birth"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  prepend-icon="mdi-calendar"
                  v-model="computedBirthDateFormatted"
                  label="Tanggal Lahir"
                  hint="MM/DD/YYYY"
                  persistent-hint
                  @blur="birthDate = parseDate(birthDateFormatted)"
                  v-on="on"
                  :rules="birthDateRules"
                  required
                ></v-text-field>
              </template>
              <v-date-picker v-model="birthDate" no-title @input="birth = false" required></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-text-field
          prepend-icon="mdi-home"
          v-model="address"
          :rules="addressRules"
          label="Alamat Lengkap"
          required
        ></v-text-field>

        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              prepend-icon="mdi-phone"
              v-model="phone"
              :rules="phoneRules"
              label="HP"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              prepend-icon="mdi-email"
              v-model="email"
              :rules="emailRules"
              label="E-mail"
              required
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              prepend-icon="mdi-phone"
              v-model="maritalStatus"
              label="Status Pernikahan"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-menu
              ref="anniversary"
              v-model="anniversary"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  prepend-icon="mdi-calendar"
                  v-model="computedAnniversaryDateFormatted"
                  label="Tanggal Pernikahan"
                  hint="MM/DD/YYYY"
                  persistent-hint
                  @blur="anniversaryDate = parseDate(anniversaryDateFormatted)"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="anniversaryDate" no-title @input="anniversary = false"></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6" lg="3">
            <v-text-field prepend-icon="mdi-briefcase" v-model="job" label="Pekerjaan"></v-text-field>
          </v-col>
          <v-col cols="12" md="6" lg="3">
            <v-text-field prepend-icon="mdi-eyedropper" v-model="bloodType" label="Golongan Darah"></v-text-field>
          </v-col>
          <v-col cols="12" md="6" lg="3">
            <v-text-field prepend-icon="mdi-school" v-model="education" label="Pendidikan Terakhir"></v-text-field>
          </v-col>
          <v-col cols="12" md="6" lg="3">
            <v-text-field prepend-icon="mdi-church" v-model="home" label="H.O.M.E."></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-select
              prepend-icon="mdi-baby"
              v-model="selectBaptized"
              :items="sudahBelum"
              label="Sudah dibaptis selam?"
              required
            ></v-select>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field prepend-icon="mdi-nutrition" v-model="ministry" label="Pelayanan"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="4" xs="4" sm="3" md="3" lg="2" xl="1">
            <v-avatar color="grey" size="110">
              <img v-if="imageUrl != ''" :src="imageUrl" />
              <span v-else class="white--text">Foto</span>
            </v-avatar>
          </v-col>
          <v-col cols="12" xs="8" sm="9" md="9" lg="10" xl="11">
            <v-file-input prepend-icon="mdi-camera" label="Upload Foto" @change="onFilePicked">
              <template v-slot:selection="{ text }">
                <v-chip small label color="primary">{{ text }}</v-chip>
              </template>
            </v-file-input>
          </v-col>
        </v-row>

        <v-row class="mt-5">
          <v-col cols="12" md="3" lg="2">
            <v-btn :disabled="!valid" color="success" class="mr-4" block @click="validate">Validate</v-btn>
          </v-col>
          <v-col cols="12" md="3" lg="2">
            <v-btn color="error" class="mr-4" block @click="reset">Reset Form</v-btn>
          </v-col>
          <v-col cols="12" md="3" lg="2">
            <v-btn color="warning" block @click="resetValidation">Reset Validation</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "Form",
  data: vm => ({
    valid: true,
    name: "",
    nameRules: [
      v => !!v || "Nama tidak boleh kosong",
      v => (v && v.length >= 3) || "Nama harus lebih dari 3 karakter"
    ],
    selectGender: "",
    gender: "",
    genders: ["Laki-laki", "Perempuan"],
    birthPlace: "",
    birthDate: new Date().toISOString().substr(0, 10),
    birthDateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    birth: false,
    birthDateRules: [v => !!v || "Tanggal lahir tidak boleh kosong"],
    address: "",
    addressRules: [v => !!v || "Alamat Lengkap tidak boleh kosong"],
    phone: "",
    phoneRules: [v => !!v || "HP tidak boleh kosong"],
    email: "",
    emailRules: [
      v => !!v || "E-mail tidak boleh kosong",
      v => /.+@.+\..+/.test(v) || "E-mail harus valid"
    ],
    maritalStatus: "",
    anniversaryDate: new Date().toISOString().substr(0, 10),
    anniversaryDateFormatted: vm.formatDate(
      new Date().toISOString().substr(0, 10)
    ),
    anniversary: false,
    job: "",
    bloodType: "",
    education: "",
    home: "",
    sudahBelum: ["Sudah", "Belum"],
    selectBaptized: "",
    ministry: "",
    imageUrl: "",
    image: null
  }),
  computed: {
    computedBirthDateFormatted() {
      return this.formatDate(this.birthDate);
    },
    computedAnniversaryDateFormatted() {
      return this.formatDate(this.anniversaryDate);
    }
  },
  methods: {
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    onFilePicked(event) {
      if (event == null) {
        this.imageUrl = "";
        this.image = null;
      }

      if (event != null) {
        let filename = event.name;

        if (filename.lastIndexOf(".") <= 0) {
          return alert("Please add a valid file!");
        }
        const fileReader = new FileReader();
        fileReader.addEventListener("load", () => {
          this.imageUrl = fileReader.result;
        });
        fileReader.readAsDataURL(event);
        this.image = event;
      }
    }
  }
};
</script>